"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.disableDebug = exports.enableDebug = exports.withTimeout = exports.Collector = exports.cloneState = exports.isTransitioning = exports.getStateName = exports.mergeStrings = exports.MergedError = exports.DEBUG_MODE = void 0;
const tslib_1 = require("tslib");
const result_1 = require("./result");
const state_flow_1 = require("./state-flow");
const state_type_1 = require("./state-type");
const symbols_1 = require("./symbols");
const debug_1 = tslib_1.__importDefault(require("debug"));
exports.DEBUG_MODE = (0, debug_1.default)('state-flow').enabled;
class MergedError extends Error {
    constructor(errors) {
        super(errors.map((e) => String(e)).join("; "));
        this.errors = errors;
    }
}
exports.MergedError = MergedError;
function mergeStrings(a, b) {
    if (a == null && b == null) {
        return undefined;
    }
    if (a == null) {
        return String(b);
    }
    if (b == null) {
        return String(a);
    }
    return `${a}; ${b}`;
}
exports.mergeStrings = mergeStrings;
function getStateName(state) {
    if (state instanceof state_type_1.StateInstance) {
        return state[symbols_1.stateNameSym];
    }
    throw new Error("invalid state");
}
exports.getStateName = getStateName;
function isTransitioning(state) {
    if (state instanceof state_type_1.StateInstance) {
        return state[symbols_1.isTransitioningSym];
    }
    if (state instanceof state_flow_1.Instance) {
        return Object.values(state).some((s) => isTransitioning(s));
    }
    throw new Error("invalid state");
}
exports.isTransitioning = isTransitioning;
function cloneState(state, changedProps) {
    if (state instanceof state_type_1.StateInstance) {
        return state_type_1.StateInstance.clone(state, changedProps);
    }
    throw new Error("invalid state");
}
exports.cloneState = cloneState;
class Collector {
    // watched: Record<string, Result> = {};
    constructor(result = result_1.Result.ignore()) {
        this.result = result;
        this.logs = {};
        this.results = [];
    }
    merge() {
        this.results = [this.results.reduce((acc, res) => acc.merge(res), this.result)];
        return this.results[0];
    }
    /**
     * Collects a result of the signal handling.
     */
    push(val) {
        const res = val instanceof result_1.Result ? val : result_1.Result.error(val);
        this.results.push(res);
    }
    log(group, ...args) {
        var _a;
        var _b;
        (_a = (_b = this.logs)[group]) !== null && _a !== void 0 ? _a : (_b[group] = []);
        this.logs[group].push(args);
    }
}
exports.Collector = Collector;
function withTimeout(promise, timeout) {
    return new Promise((resolve, reject) => {
        const timer = setTimeout(() => {
            resolve(result_1.Result.error(new Error("timeout")));
        }, timeout);
        promise.then((res) => {
            clearTimeout(timer);
            resolve(res);
        }, (err) => {
            clearTimeout(timer);
            reject(err);
        });
    });
}
exports.withTimeout = withTimeout;
function enableDebug() {
    exports.DEBUG_MODE = true;
}
exports.enableDebug = enableDebug;
function disableDebug() {
    exports.DEBUG_MODE = false;
}
exports.disableDebug = disableDebug;
//# sourceMappingURL=utils.js.map